module.exports = __webpack_public_path__ + "static/img/product_lotus2_hero.da43378.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product_lotus2_hero.jpg
// module id = WZJi
// module chunks = 1